import React, {useContext} from 'react';
import Context from '../OriginStoryProvider';

const SquareImg1 = () => {
	const { data: {content} } = useContext(Context);

	return (
		<div className='chapter-2__square-img--1 main-grid'>
			<div className='main-grid__margin'></div>
			<figure className='main-grid__body'>
				<img className='chapter-2__square-img--1__img bg-shape' src={`${mainScript.assetPath}images/jpg/chapter-2/norton-breaking-ground-home-1890.jpg`} alt={content.chapters.second.square_img_1.img_alt} loading="lazy"/>
				<figcaption className='chapter-2__square-img--1__caption'><p className='img-caption'>{content.chapters.second.square_img_1.img_caption}</p></figcaption>
			</figure>
			<div className='main-grid__margin'></div>
		</div>
	)
}

export default SquareImg1;